import { useEffect } from 'react';

/**
 * Setzt <meta name="robots" content="noindex, nofollow"> für private Seiten
 * und stellt den vorherigen Wert beim Verlassen wieder her.
 */
export const useNoIndex = () => {
  useEffect(() => {
    let tag = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    let created = false;
    const previous = tag?.getAttribute('content') ?? null;

    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'robots');
      document.head.appendChild(tag);
      created = true;
    }
    tag.setAttribute('content', 'noindex, nofollow');

    return () => {
      if (!tag) return;
      if (created) {
        tag.remove();
      } else if (previous !== null) {
        tag.setAttribute('content', previous);
      }
    };
  }, []);
};